import React, { useState } from "react";
import { AssignedAccountsTblPopUp } from "../../TeamLeaderView/AgentsKPIModels/AgentsKPIModels";
import { AccountAssignmentModal, UserMembershipModal } from "./EmployeeMappingModels";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeMappingData, updateUsermembershipDeleteStart } from "../../../actions/employeeMapping.action";
import deleteIcon from './../../../assets/onboard-images/Delete_Icon.png'


const EmployeeMapping = () => {
  const dispatch = useDispatch();
  const employeeMappingData = useSelector(
    (state) => state.EmployeeMappingReducer.employeeMappingData
  );

  const [addUserModel, setAddUserModel] = useState(false);
  const [addUserMappingModel, setAddUserMappingModel] = useState(false);
  const [email, setEmail] = useState("");

  // delete popup
  const [showConfirm, setShowConfirm] = useState(false);
  const [deletePayload, setDeletePayload] = useState(null);

  const firstObj = employeeMappingData[0] || {};
  const userDetails = firstObj.UserDetails?.[0] || {};
  const sections = Object.entries(firstObj).filter(
    ([key]) => key !== "UserDetails"
  );

  // detect id column dynamically
  const getIdKey = (row) =>
    Object.keys(row).find((k) => k.toLowerCase().endsWith("id"));

  // check if Delete column exists for a table
  const hasDeleteColumn = (rows) =>
    Array.isArray(rows) && rows.some((r) => "Delete" in r);

  const handleDeleteClick = (section, row) => {
    const idKey = getIdKey(row);
    if (!idKey) return;

    setDeletePayload({
      section,
      idKey,
      idValue: row[idKey],
    });
    setShowConfirm(true);
  };

  const handleConfirmDelete = () => {
    console.log("DELETE PAYLOAD 👉", deletePayload);

    dispatch(updateUsermembershipDeleteStart([{"UserMembershipID":deletePayload.idValue}],
    ()=>{
      dispatch(getEmployeeMappingData(email))
    }
    ))

    setShowConfirm(false);
    setDeletePayload(null);
  };

      console.log("DELETE PAYLOAD 👉", deletePayload);


  return (
    <div style={{ padding: 16 }}>
      <div className="Applications_Title" style={{ marginBottom: 20 }}>
        Employee Mapping
      </div>

      {/* Search */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ display: "flex", marginBottom: 20 }}>
            <div>
              <label>Enter Email</label>
              <input
                type="text"
                placeholder="Example: abc@dxc.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div
              className="btn_adduser"
              onClick={() => dispatch(getEmployeeMappingData(email))}
            >
              Search
            </div>

            <div className="btn_adduser" onClick={() => setAddUserModel(true)}>
              Add User
            </div>
          </div>

          <div style={{ display: "flex", gap: "20px" }}>
            {Object.entries(userDetails).map(([label, value]) => (
              <div
                key={label}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label>{label}</label>
                <div>{String(value)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tables */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 20 }}>
        {sections.map(([key, rows]) => (
          <div
            key={key}
            style={{
              width: "calc(50% - 20px)",
              border: "1px solid #ccc",
              padding: 12,
              borderRadius: 6,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h6>{key}</h6>
              {key === "UserMembership" && (
                <h6
                  style={{ cursor: "pointer", color: "blue" }}
                  onClick={() => setAddUserMappingModel(true)}
                >
                  ADD
                </h6>
              )}
            </div>

            {Array.isArray(rows) && rows.length > 0 ? (
              <div style={{ maxHeight: 180, overflow: "auto" }}>
                <table className="aquaa-table" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      {Object.keys(rows[0])
                        .filter(
                          (c) =>
                            c !== "Delete" &&
                            !c.toLowerCase().endsWith("id")
                        )
                        .map((col) => (
                          <th key={col}>{col}</th>
                        ))}

                      {hasDeleteColumn(rows) && <th>Action</th>}
                    </tr>
                  </thead>

                  <tbody>
                    {rows.map((row, i) => (
                      <tr key={i}>
                        {Object.keys(rows[0])
                          .filter(
                            (c) =>
                              c !== "Delete" &&
                              !c.toLowerCase().endsWith("id")
                          )
                          .map((col) => (
                            <td key={col}>{row[col] ?? "-"}</td>
                          ))}

                        {hasDeleteColumn(rows) && (
                          <td>
                            {row.Delete === 1 && (
                              <span
                                style={{ color: "red", cursor: "pointer" }}
                                onClick={() => handleDeleteClick(key, row)}
                              >
                                <img src={deleteIcon} alt=''/>
                              </span>
                            )}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No Data</p>
            )}
          </div>
        ))}
      </div>

      {/* Modals */}
      {addUserModel && (
        <AssignedAccountsTblPopUp
          isOpen={addUserModel}
          setShowModal={setAddUserModel}
        >
          <UserMembershipModal closeModel={() => setAddUserModel(false)} />
        </AssignedAccountsTblPopUp>
      )}

      {addUserMappingModel && (
        <AssignedAccountsTblPopUp
          isOpen={addUserMappingModel}
          setShowModal={setAddUserMappingModel}
        >
          <AccountAssignmentModal
            closeModel={() => setAddUserMappingModel(false)}
            agent={email}
          />
        </AssignedAccountsTblPopUp>
      )}

      {/* <Modal show={showConfirm} centered onHide={() => setShowConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this record?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal> */}

       {showConfirm && (
        <AssignedAccountsTblPopUp
          isOpen={showConfirm}
          setShowModal={setShowConfirm}
        >
         <div>  Are you sure you want to delete this record?</div>
         <main style={{ display: 'flex', gap: '30px',justifyContent:'center'}}>
            <button type='submit' className='btn_adduser' onClick={handleConfirmDelete}> DELETE
            </button>
            <button className='btn_canceluser' onClick={() => setShowConfirm(false)}>CANCEL
            </button>
          </main>
        </AssignedAccountsTblPopUp>
      )}
    </div>
  );
};

export default EmployeeMapping;
